import type { BetSlipState } from '../types';
import { getSelectionsFromSingleOpportunities } from '../utils/getSelectionsFromSingleOpportunities';

/**
 * Ensures the selections reset to whats actually in the customers bet slip upon failures
 * This ensures the catalogue and bet slip are always aligned.
 */
const betSlipUpdateFailed = (state: BetSlipState): BetSlipState => {
  let { selections } = state;
  const selectionsRequireResetting = state.opportunities.SINGLE.length !== selections.length;

  // To avoid recursive API calls, we should only update selections when they are
  // different to the opportunities available in the bet slip.
  if (selectionsRequireResetting) {
    selections = getSelectionsFromSingleOpportunities(state.opportunities.SINGLE);
  }

  return {
    ...state,
    errorCode: 'BET_SLIP_UPDATE_FAILED',
    selections,
    fetchStatus: 'READY'
  };
};

export default betSlipUpdateFailed;
